import { useTranslation } from "react-i18next";

import { ICON_DEFAULT_STYLE } from "@/shared";

import { OpenInNewIcon } from "@dotnet/telematics-design-system";

import ListChoice from "../../../../../ListChoice/ListChoice";
import { DriverScheduleDto, ScheduleDto } from "../../../../types";

interface IScheduleHistoryButtonProps {
  schedule: ScheduleDto | DriverScheduleDto;
}

const ScheduleHistoryButton = ({ schedule }: IScheduleHistoryButtonProps) => {
  const { t } = useTranslation();

  return (
    <ListChoice
      title={t("Details##schedule history")}
      iconLeft={<OpenInNewIcon style={ICON_DEFAULT_STYLE} />}
      onClick={() => console.log("click driver schedule history", schedule)}
      alignIconCenter
    />
  );
};

export default ScheduleHistoryButton;
